module.exports = __webpack_public_path__ + "static/media/init-pq-panel.f6f6b582.svg";